import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { BookOpen } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { useSeo } from "@/components/site/Seo";
import { API, assetUrl, fill } from "@/lib/api";
import { Rich } from "@/components/site/Rich";

const isEmpty = (html) => !html || !html.replace(/<[^>]*>|&nbsp;/g, "").trim();

export default function SchoolPage() {
  const { slug } = useParams();
  const { content } = useSite();
  const [school, setSchool] = useState(null);
  const [missing, setMissing] = useState(false);
  useSeo("school", { school: school?.name || "School", city: school?.group || "" });

  useEffect(() => {
    setSchool(null);
    setMissing(false);
    axios.get(`${API}/schools/${slug}`).then((r) => setSchool(r.data)).catch(() => setMissing(true));
  }, [slug]);

  if (missing) return <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="school-not-found"><h1 className="font-serif text-3xl font-bold">School not found</h1><Link to="/" className="mt-6 inline-block text-brand underline">Back to home</Link></div>;
  if (!school) return <div className="py-32 grid place-items-center"><div className="h-8 w-8 rounded-full border-2 border-brand border-t-transparent animate-spin" /></div>;

  const sp = content.school_page;
  return (
    <div data-testid="school-page">
      <section className="bg-ivory-alt border-b border-charcoal/10">
        <h1 className="max-w-4xl mx-auto px-6 py-8 sm:py-10 text-center font-serif text-2xl sm:text-3xl text-charcoal" data-testid="school-name">{school.name}</h1>
      </section>
      <section className="max-w-[1100px] mx-auto px-6 py-12 sm:py-16">
        {school.image && (
          <div className="mx-auto mb-10 p-[4%]" style={{ width: `${school.image_width || 100}%`, background: school.image_bg || sp.image_bg }} data-testid="school-image-box">
            <img src={assetUrl(school.image)} alt={school.name} className="block w-full h-auto" data-testid="school-image" />
          </div>
        )}
        {isEmpty(school.content) ? (
          <div className="text-center max-w-2xl mx-auto" data-testid="school-placeholder">
            <p className="text-lg leading-relaxed text-charcoal/80">{fill(sp.placeholder, { school: school.name, city: school.group })}</p>
            <Link to="/digital-edition" className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand hover:bg-brand-dark text-white px-6 py-3 text-sm font-bold transition-colors" data-testid="school-digital-button">
              <BookOpen className="h-4 w-4" />{sp.button}
            </Link>
          </div>
        ) : (
          <Rich html={school.content} className="text-charcoal/85" data-testid="school-content" />
        )}
      </section>
    </div>
  );
}
